import { Link } from "gatsby";
import React from "react";
export default function NewCertifyLegal({
  backgroundCol,
  head,
  colHead,
  secondHead,
  para,
  leftHeadingFirst,
  leftHeadingmid,
  leftHeadingSecond,
  leftHeadingPara,
  src,
  bottomleftHeadingFirst,
  bottomleftHeadingmid,
  bottomleftHeadingSecond,
  bottomleftHeadingPara,
  RightHeadingFirst,
  RightHeadingmid,
  RightHeadingSecond,
  RightHeadingPara,
  ListFirst,
  ListSecond,
  ListThird,
  ListFourth,
}) {
  return (
    <div className={backgroundCol ? backgroundCol : "bg-midBlue"}>
      <div className="mainDiv flex lg:flex-col flex-wrap mx-auto justify-center w-full lg:w-10/12 pt-24 max-w-6xl">
        <div className="divTop  flex flex-col justify-center items-center relative">
          <img src="https://tomedes.gumlet.io/frontend/images/services-new/legal_translation.svg" alt="" className="absolute -top-5 inline-block w-full lg:w-10/12" />
          <h2 className="md:text-[45px] leading-[60px] text-2xl text-center text-white font-extrabold uppercase z-50 mt-4">
            <span className="text-orange">WHAT</span>
            <br />
            <span>IS LEGAL TRANSLATION?</span>
          </h2>
          <p className="text-center text-white text-[18px] font-light py-6 px-4 md:px-0 font-opensans">
            {para
              ? para
              : "Legal translation is one of the most sensitive fields in translation, a mistranslation can lead to malpractice lawsuits or in more extreme cases, it can cost someone's freedom. We deal with legal translations with the utmost care and consideration."}
          </p>
        </div>
        <div className="div flex flex-wrap mx-auto justify-center py-24 lg:px-0 px-4 gap-x-32">
          <div className="leftText text-white w-full lg:w-4/12 flex-col">
            <h3 className="text-[26px] leading-[40px] font-secondary font-normal pb-6">
              {leftHeadingFirst ? leftHeadingFirst : "Legal Translation-"}
              <span className="text-orange">Defined</span>
            </h3>
            <p className="font-extralight font-opensans text-sm leading-loose">
              {leftHeadingPara
                ? leftHeadingPara
                : "Legal translation is the field of translation that transforms legal materials from one language to another. Since law is dependent on culture, it takes more than translations but also a knowledge of two or more countries' legal systems for legal translations to work."}
              <br />
              <br />
            </p>
          </div>
          <div className="rightComponent text-white  w-full lg:w-4/12 flex-col lg:pt-0 pt-6">
            <h3 className="text-[26px] font-secondary font-normal pb-6 leading-[40px]" style={{ lineHeight: "40px", fontSize: "26px" }}>
              <span className="text-orange">Certifying </span> The legal translation <span className="text-orange">process</span>
            </h3>
            <ul className="divcontent  list-outside pb-8 md:pb-14 mt-6 list-none">
              <li className="text-orange">
                <span>1. </span>
                <span className="text-white text-sm  font-extralight leading-relaxed">Project management</span>
              </li>
              <li className="text-orange pt-4">
                <span>2. </span>
                <span className="text-white text-sm  font-extralight leading-relaxed">Legal analysis</span>
              </li>
              <li className="text-orange pt-4">
                <span>3. </span>
                <span className="text-white text-sm  font-extralight leading-relaxed">Translation</span>
              </li>
              <li className="text-orange pt-4">
                <span>4. </span>
                <span className="text-white text-sm  font-extralight leading-relaxed">LQA</span>
              </li>
            </ul>
          </div>
          <div className="divcontent rightComponent text-white flex-wrap md:flex-nowrap justify-between w-full lg:w-9/12 flex lg:pt-0 pt-6">
            <div className="div">
              <h3 className="text-2xl font-secondary font-bold pt-0 md:pt-[2.5rem] leading-10 mb-4">
                How Do We <span className="text-orange">Hire</span> Your Legal Translator?
              </h3>
              <p className="mb-3">Learn more about our translator selection process.</p>
              <Link to="/quality-guarantee" className="rounded-full py-2 px-6 bg-orange hover:bg-[#ff9a16] transition-colors duration-300">
                LEARN MORE
              </Link>
            </div>
            <div className="div flex w-full  md:w-[50%]">
              <p className="font-extralight font-opensans text-sm py-10 leading-relaxed">
                Our legal translation agency facilitates a 2-step hiring process to hire translators. We use a combination of human reviewers and QA platforms to assess the linguistic and law
                expertise of each translator applicant. Then their work is audited via our internal review system using the factors of client feedback, professionalism, and consistency. When it comes
                to legal translators, we take into account their knowledge of two or more countries' laws and regulations.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
